/**
 * Shared news page light/dark surface tokens.
 * Dark values match the existing news chrome; light matches the mobile mockup.
 */

export const NEWS_THEME = {
  dark: {
    pageBg: '#0c111a',
    stickyBg: '#0c111a',
    cardBg: '#1F242D',
    cardShadow: '#070b12',
    searchFieldBg: '#1F242D',
    searchFieldText: '#ffffff',
    searchFieldBorder: 'rgba(255,255,255,0.15)',
    searchFieldBorderHover: 'rgba(255,255,255,0.28)',
    searchFieldBorderFocus: '#ffffff',
    placeholder: '#94a3b8',
    filterBorder: 'rgba(255,255,255,0.15)',
    filterText: '#ffffff',
    headline: '#ffffff',
    author: '#94a3b8',
    date: '#94a3b8',
    companyName: '#ffffff',
    statusText: '#94a3b8',
    moreIcon: '#ffffff',
    circleButtonBg: '#191f29',
    circleButtonBorder: '#0c111a',
    circleButtonColor: '#ffffff',
    circleButtonHover: '#232a36',
    shareIcon: '#ffffff',
    menuIcon: 'white',
    horizontalLogo: '/static/news/1000containers-horizontal-white.svg',
    matchDivider: 'rgba(255,255,255,0.12)',
    matchHeading: '#ffffff',
    whyItMattersBg: '#F2F8FC',
    whyItMattersBorder: '#DCEAF3',
    whyItMattersDivider: '#D3E3EE',
    whyItMattersLabel: '#1A8BC0',
    whyItMattersText: '#64748B',
    whyItMattersChevron: '#94A3B8',
  },
  light: {
    pageBg: '#F4F7F9',
    stickyBg: '#F4F7F9',
    cardBg: '#ffffff',
    cardShadow: 'rgba(15, 23, 42, 0.08)',
    searchFieldBg: '#ffffff',
    searchFieldText: '#0F172A',
    searchFieldBorder: '#E5E7EB',
    searchFieldBorderHover: '#CBD5E1',
    searchFieldBorderFocus: '#009eda',
    placeholder: '#94A3B8',
    filterBorder: '#E5E7EB',
    filterText: '#0F172A',
    headline: '#0F172A',
    author: '#6B7280',
    date: '#6B7280',
    companyName: '#0F172A',
    statusText: '#6B7280',
    moreIcon: '#64748B',
    circleButtonBg: '#ffffff',
    circleButtonBorder: 'rgba(15, 23, 42, 0.12)',
    circleButtonColor: '#0F172A',
    circleButtonHover: '#F8FAFC',
    shareIcon: '#0F172A',
    menuIcon: '#0F172A',
    /** Same asset as inventory mobile light header. */
    horizontalLogo: '/static/news/1000containers-horizontal-dark.svg',
    matchDivider: 'rgba(15, 23, 42, 0.12)',
    matchHeading: '#0F172A',
    whyItMattersBg: '#F2F8FC',
    whyItMattersBorder: '#DCEAF3',
    whyItMattersDivider: '#D3E3EE',
    whyItMattersLabel: '#1A8BC0',
    whyItMattersText: '#64748B',
    whyItMattersChevron: '#94A3B8',
  },
};

export function getNewsThemeTokens(lightTheme) {
  return lightTheme ? NEWS_THEME.light : NEWS_THEME.dark;
}
